'use client';
import React, { createContext, ReactNode, useEffect, useState, useContext } from "react";

const ShopCurrencyContext = createContext<any>(null);

export const ShopCurrencyProvider = ({
    children, 
    shopCurrency
}: {
    children: ReactNode;
    shopCurrency: any;
}) => {

    const [data, setData] = useState<any>(null);
    
    useEffect(() => {
        if (!shopCurrency) return;

        setData(shopCurrency);
    }, [shopCurrency]);

    return <ShopCurrencyContext.Provider value={data}>{children}</ShopCurrencyContext.Provider>;
}

export default ShopCurrencyContext;

export const useShopCurrency = () => useContext(ShopCurrencyContext);